import { create } from "sheetly";
export let text = ".title{margin:.5em 1em;padding:.5em 1em;border-bottom:1px var(--bs-border-color) solid}.title::before{display:block;content:\" \";position:absolute;left:1.25em;width:.125em;height:1.4em;background-color:var(--bs-primary)}";
export const sheet = create(text, import.meta.url);
